import { render } from "./GridNurseBio.vue?vue&type=template&id=4753bcb5&scoped=true"
import script from "./GridNurseBio.vue?vue&type=script&lang=js"
export * from "./GridNurseBio.vue?vue&type=script&lang=js"

import "./GridNurseBio.vue?vue&type=style&index=0&id=4753bcb5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4753bcb5"]])

export default __exports__